export default "__VITE_ASSET__DhW0Sq0h__"